import { RoleHost } from '../RoleHost';

export function SWrapper() {
  return <RoleHost role="s" />;
}
